/**
 * Accept the URL people actually type.
 *
 * The server only allows http/https (`resolveBaseUrl` in routes/uiAuditRouter.js, and
 * `resolveAuditTarget` for the chat tool), so a bare "example.com" comes back as a
 * validation error for a convention nobody types by hand. Prepending the scheme is the
 * difference between a form that works and one that scolds you.
 *
 * Deliberately NOT a full validator: the server screens the URL properly (including the
 * SSRF check on the resolved address, which a client can neither do nor be trusted for).
 * This only fixes the one omission that is always safe to fix.
 */
export function normalizeAuditUrl(raw) {
  const trimmed = String(raw ?? '').trim();
  if (!trimmed) return '';
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}
